import defaultAvatar from "@/assets/images/avatar.jpg";

export const OFFICIAL_AUTHOR_NAME = "官方出品";
export const OFFICIAL_AUTHOR_AVATAR =
  "https://ruixin-ai.oss-cn-hangzhou.aliyuncs.com/universe/universe.png";

export function isOfficialSpace(space) {
  if (!space) return false;
  return !space.userId || space.category === "official";
}

export function getSpaceAuthorName(space) {
  if (space?.authorName) return space.authorName;
  if (isOfficialSpace(space)) return OFFICIAL_AUTHOR_NAME;
  return space?.author || "匿名用户";
}

export function getSpaceAuthorAvatar(space) {
  if (space?.authorAvatar) return space.authorAvatar;
  if (isOfficialSpace(space)) return OFFICIAL_AUTHOR_AVATAR;
  return defaultAvatar;
}
